const fabTournamentEditorConfig = {
  initialContent: {
    page_title: "",
    section_title: "",

    intro_paragraph_one: "",
    intro_paragraph_two: "",
    intro_paragraph_three: "",
    intro_paragraph_four: "",
    intro_paragraph_five: "",

    tournament_list_title: "",

    hero_image_url: "",
    bottom_image_one_url: "",
    bottom_image_two_url: "",
    bottom_image_three_url: "",
  },

imageFields: {
  hero: {
    contentKey: "hero_image_url",
  },

  bottomOne: {
    contentKey: "bottom_image_one_url",
  },

  bottomTwo: {
    contentKey: "bottom_image_two_url",
  },

  bottomThree: {
    contentKey: "bottom_image_three_url",
  },
},

  loadContent(content = {}) {
    return {
      ...this.initialContent,
      ...content,
    };
  },

  buildContent(templateState = {}, sharedState = {}) {
    return {
      page_title:
        templateState.page_title?.trim() || "",
      section_title:
        templateState.section_title?.trim() || "",

      intro_paragraph_one:
        templateState.intro_paragraph_one?.trim() || "",
      intro_paragraph_two:
        templateState.intro_paragraph_two?.trim() || "",
      intro_paragraph_three:
        templateState.intro_paragraph_three?.trim() || "",
      intro_paragraph_four:
        templateState.intro_paragraph_four?.trim() || "",
      intro_paragraph_five:
        templateState.intro_paragraph_five?.trim() || "",

      tournament_list_title:
        templateState.tournament_list_title?.trim() || "",

hero_image_url:
  sharedState.resolvedImageUrls?.hero || "",

bottom_image_one_url:
  sharedState.resolvedImageUrls?.bottomOne || "",

bottom_image_two_url:
  sharedState.resolvedImageUrls?.bottomTwo || "",

bottom_image_three_url:
  sharedState.resolvedImageUrls?.bottomThree || "",
    };
  },

getStep2Props({
  templateState,
  setTemplateField,
  getImageField,
  setImageFile,
  setImageRemoved,
}) {
  const hero = getImageField("hero");
  const bottomOne = getImageField("bottomOne");
  const bottomTwo = getImageField("bottomTwo");
  const bottomThree = getImageField("bottomThree");

  return {
    templateState,
    setTemplateField,

    heroImageFile: hero.file,
    setHeroImageFile: (file) =>
      setImageFile("hero", file),
    existingHeroImageUrl: hero.existingUrl,
    removeHeroImage: hero.remove,
    setRemoveHeroImage: (remove) =>
      setImageRemoved("hero", remove),

    bottomImageOneFile: bottomOne.file,
    setBottomImageOneFile: (file) =>
      setImageFile("bottomOne", file),
    existingBottomImageOneUrl: bottomOne.existingUrl,
    removeBottomImageOne: bottomOne.remove,
    setRemoveBottomImageOne: (remove) =>
      setImageRemoved("bottomOne", remove),

    bottomImageTwoFile: bottomTwo.file,
    setBottomImageTwoFile: (file) =>
      setImageFile("bottomTwo", file),
    existingBottomImageTwoUrl: bottomTwo.existingUrl,
    removeBottomImageTwo: bottomTwo.remove,
    setRemoveBottomImageTwo: (remove) =>
      setImageRemoved("bottomTwo", remove),

    bottomImageThreeFile: bottomThree.file,
    setBottomImageThreeFile: (file) =>
      setImageFile("bottomThree", file),
    existingBottomImageThreeUrl: bottomThree.existingUrl,
    removeBottomImageThree: bottomThree.remove,
    setRemoveBottomImageThree: (remove) =>
      setImageRemoved("bottomThree", remove),
  };
},
};

export default fabTournamentEditorConfig;